import { useMemo } from "react";

import { useHistory } from "react-router";
import { Button } from "@mui/material";

import { useCustomerId } from "../../hooks/useCustomerId";
import { LensEnticement } from "../../LensEnticement/LensEnticement";
import { type EnticementState } from "../../LensEnticement/types";
import useFetchAmTamEmail from "../../NoEntitlement/hooks";
import { ContactSalesButton } from "../../NoEntitlement/NoEntitlement";
import { getFriendlyIntegrationName, getIntegrationLensText, getIntegrationLensUrl } from "./utils";

type IntegrationEntitlementProps = {
  state: EnticementState;
  integrationName: string;
};

export const IntegrationEntitlement = ({ state, integrationName }: IntegrationEntitlementProps) => {
  const history = useHistory();
  const customerId = useCustomerId();
  const { accountManagers, loading } = useFetchAmTamEmail();

  const friendlyIntegrationName = getFriendlyIntegrationName(integrationName);

  const button = useMemo(() => {
    if (state === "activate") {
      return (
        <Button
          variant="contained"
          sx={{ width: "fit-content" }}
          onClick={() => {
            history.push(`/customers/${customerId}/cloud-onboarding-${integrationName}`);
          }}
        >
          Connect your {friendlyIntegrationName} account
        </Button>
      );
    }

    if (state === "upgrade") {
      return <ContactSalesButton sendTo={accountManagers} loading={loading} />;
    }
  }, [state, friendlyIntegrationName, history, customerId, integrationName, accountManagers, loading]);

  return (
    <LensEnticement
      title={getIntegrationLensText(integrationName).TITLE}
      listItems={getIntegrationLensText(integrationName).LIST}
      actionButton={button}
      learnMoreUrl={getIntegrationLensUrl(integrationName)}
    />
  );
};
